// extracted by mini-css-extract-plugin
export default {"comment_input":"Chatting_comment_input__LpWxY","send_button":"Chatting_send_button__hG4WL","input_wrapper":"Chatting_input_wrapper__fC-B4"};